import {SportstypeSpec} from "../types";
import main from "../../icons/_custom_worldrowing/WorldRowing";
import camera from "../../icons/_custom_worldrowing/camera";
import ergo from "../../icons/_custom_worldrowing/ergo";
import finishFlag from "../../icons/_custom_worldrowing/finish-flag";
import iconPoll from "../../icons/_custom_worldrowing/icon-poll";
import important from "../../icons/_custom_worldrowing/important";
import quote from "../../icons/_custom_worldrowing/quote";
import stopwatch from "../../icons/_custom_worldrowing/stopwatch";
import under19 from "../../icons/_custom_worldrowing/under19";
import under23 from "../../icons/_custom_worldrowing/under23";
import video from "../../icons/_custom_worldrowing/video";
import yellowcard from "../../icons/_custom_worldrowing/yellowcard";

const _custom_worldrowing: SportstypeSpec = {
  id: '_custom_worldrowing',
  svg: main,
  releaseStage: 'released',
  events: [
    {
      id: 'worldrowing',
      important: true,
      svg: main
    },
    {
      id: 'camera',
      important: true,
      svg: camera
    },
    {
      id: 'ergo',
      important: true,
      svg: ergo
    },
    {
      id: 'finish-flag',
      important: true,
      svg: finishFlag
    },
    {
      id: 'icon-poll',
      important: true,
      svg: iconPoll
    },
    {
      id: 'important',
      important: true,
      svg: important
    },
    {
      id: 'quote',
      important: true,
      svg: quote
    },
    {
      id: 'stopwatch',
      important: true,
      svg: stopwatch
    },
    {
      id: 'under19',
      important: true,
      svg: under19
    },
    {
      id: 'under23',
      important: true,
      svg: under23
    },
    {
      id: 'video',
      important: true,
      svg: video
    },
    {
      id: 'yellowcard',
      important: true,
      svg: yellowcard
    },
  ]
}

export default _custom_worldrowing
